import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/GetMapNows/Get`, payload),
    GetDashBoardProcess: (payload) => Repository.post(`/api/GetMapNows/GetDashBoardProcess`, payload),
    GetChartProcess: (payload) => Repository.post(`/api/GetMapNows/GetChartProcess`, payload),
    GetDashBoardDetail: (payload) => Repository.post(`/api/GetMapNows/GetDashBoardDetail`, payload),
}
